const MONTHLY_PAYROLL_UPDATE = 'bfb/monthly_payroll/MONTHLY_PAYROLL_UPDATE';

export default {
  MONTHLY_PAYROLL_UPDATE,
};
